import { render, staticRenderFns } from "./MultiLineText.vue?vue&type=template&id=06d5f3bc&scoped=true"
import script from "./MultiLineText.vue?vue&type=script&lang=js"
export * from "./MultiLineText.vue?vue&type=script&lang=js"
import style0 from "./MultiLineText.vue?vue&type=style&index=0&id=06d5f3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5f3bc",
  null
  
)

export default component.exports